export const BrandMarqueeFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description:
        "Section heading that frames the brand list (e.g. 'Brands We Service')",
      seo: true,
      key: "brandMarquee.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description:
        "Optional short line reinforcing trust and breadth (e.g. 'Major and high-end appliances')",
      seo: true,
      key: "brandMarquee.subheading",
    },
  },
  displayMode: {
    type: "radio",
    label: "Display Mode",
    options: [
      { label: "Logos only", value: "logos" },
      { label: "Names only", value: "names" },
      { label: "Mixed (logo when uploaded, name otherwise)", value: "mixed" },
    ],
    metadata: {
      source: "manual",
    },
  },
  mediaStyle: {
    type: "radio",
    label: "Image Style",
    options: [
      { label: "Logos (compact, grayscale)", value: "logo" },
      { label: "Covers (tall, full color)", value: "cover" },
    ],
    metadata: {
      source: "manual",
      description:
        "Covers suit portrait artwork like magazine covers, awards, or certificates; logos suit wide brand marks",
    },
  },
  scrolling: {
    type: "radio",
    label: "Scrolling",
    options: [
      { label: "Scroll horizontally", value: "yes" },
      { label: "Static (wrap)", value: "no" },
    ],
    metadata: {
      source: "manual",
    },
  },
  spacing: {
    type: "select",
    label: "Spacing",
    options: [
      { label: "Tight", value: "tight" },
      { label: "Default", value: "default" },
      { label: "Relaxed", value: "relaxed" },
      { label: "Loose", value: "loose" },
    ],
    metadata: {
      source: "manual",
      description: "Horizontal gap between items",
    },
  },
  chipStyle: {
    type: "select",
    label: "Name Chip Style",
    options: [
      { label: "Pill (rounded full + border)", value: "pill" },
      { label: "Rounded (subtle radius + border)", value: "rounded" },
      { label: "Sharp (no radius + border)", value: "sharp" },
      { label: "None (plain text, no border)", value: "none" },
    ],
    metadata: {
      source: "manual",
      description: "Style for brand-name fallback chips (only applies when no logo is uploaded or in Names mode)",
    },
  },
  shadow: {
    type: "radio",
    label: "Chip Shadow",
    options: [
      { label: "On", value: "yes" },
      { label: "Off", value: "no" },
    ],
    metadata: {
      source: "manual",
      description: "Subtle drop shadow on bordered chips",
    },
  },
  brands: {
    type: "array",
    label: "Brands",
    metadata: {
      source: "manual",
      description: "Brand logos or names displayed in the marquee",
      seo: true,
      key: "brandMarquee.brands",
    },
    getItemSummary: (item: { name?: string }) => item.name || "Brand",
    arrayFields: {
      name: {
        type: "text",
        label: "Brand Name",
        metadata: {
          description: "Brand name — used as alt text for the logo and shown when no logo is uploaded",
          seo: true,
        },
      },
      logoUrl: {
        type: "custom",
        label: "Logo",
        metadata: {
          description: "Optional brand logo. If empty, the brand name displays as a text chip.",
        },
      },
      href: {
        type: "text",
        label: "Link URL (optional)",
        metadata: {
          description: "Optional URL — e.g. /services/lg-repair",
        },
      },
    },
    defaultItemProps: {
      name: "",
      logoUrl: "",
      href: "",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;
